import SearchIcon from "@mui/icons-material/Search";
import { useContext } from "react";
import { GameContext } from "../GameContext/GameContext";
import { InputAdornment, TextField } from "@mui/material";
import { FormControl } from "@mui/base";

const Filter = () => {
  const { filterText, setFilterText } = useContext(GameContext);
  const handleChange = (e) => {
    setFilterText(e.target.value);
  };

  return (
    <FormControl variant="standard">
      <TextField
        fullWidth
        value={filterText}
        onChange={handleChange}
        type="search"
        variant="standard"
        size="medium"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="medium" htmlColor="black" />
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};

export default Filter;
